<template>
    <div class="container">
        <template v-if="loader_loading">
            <br />
            <div class="text-center text-muted">
                <font-awesome-icon icon="fas fa-circle-notch" size="2x" spin />
                <p>Loading data</p>
            </div>
        </template>

        <template v-if="!voucher_data.id && !loader_loading">
            <div class="card">
                <div class="card-body">
                    <h4 class="text-muted text-center mb-0">No data available</h4>
                </div>
            </div>
        </template>

        <template v-if="voucher_data.id && !loader_loading">
            <div :class="{ 'cs-card-disabled': !voucher_data.display_status }" class="card border-0 cs-shadow mx-2">
                <img v-if="voucher_data.img_json && voucher_data.img_json['2_1']" :src="voucher_data.img_json['2_1']" class="card-img" />

                <div class="card-body cs-ticket-style">
                    <h5 class="card-title" style="color: #333">{{ voucher_data.name }}</h5>

                    <div v-if="voucher_data.description">
                        <small>
                            <p class="text-secondary mb-1" v-html="$parent.convertNewlineToBr(voucher_data.description)"></p>
                        </small>
                    </div>

                    <br />
                    <hr />

                    <div class="row text-center">
                        <div class="col-6">
                            <p class="mb-0 cs-label">Available From</p>
                            <p>
                                {{ voucher_data.valid_obj.valid_from_date_str }}
                                <span>
                                    <br />
                                    {{ voucher_data.valid_obj.valid_from_time_str }}
                                </span>
                            </p>
                        </div>

                        <div class="col-6">
                            <p class="mb-0 cs-label">Expired On</p>
                            <p>
                                {{ voucher_data.valid_obj.valid_to_date_str }}
                                <span>
                                    <br />
                                    {{ voucher_data.valid_obj.valid_to_time_str }}
                                </span>
                            </p>
                        </div>

                        <div class="col-6 pe-0" v-if="voucher_data.amount">
                            <p class="mb-0 cs-label">Price</p>
                            <h3>
                                <span v-if="voucher_data.ori_amount" class="text-body-tertiary text-decoration-line-through me-1" style="font-size: 0.8rem"> {{ voucher_data.ori_amount_str }}</span>
                                <span class="cs-text-gradient fw-bold">
                                    <span v-if="voucher_data.amount == '0.00'">FREE</span>
                                    <span v-if="voucher_data.amount !== '0.00'">{{ voucher_data.amount_str }}</span>
                                </span>
                            </h3>
                        </div>

                        <div class="col-6">
                            <template v-if="voucher_data.display_status">
                                <template v-if="voucher_data.stock != 99999">
                                    <p class="mb-0 cs-label">Remaining</p>
                                    <p>{{ voucher_data.stock }}</p>
                                </template>
                            </template>
                        </div>
                    </div>
                </div>

                <div class="container cs-ticket-style">
                    <br />
                    <div class="d-grid gap-2 mb-2" v-if="voucher_data.display_status">
                        <button @click="collectVoucher()" :disabled="btn_loading || !voucher_data.display_status" class="btn cs-btn-default btn-lg mb-1">
                            <span v-if="!btn_loading"> Collect </span>
                            <span v-if="btn_loading">
                                <font-awesome-icon icon="fas fa-circle-notch" spin />
                            </span>
                        </button>
                    </div>

                    <!-- <div class="d-grid gap-2 mb-2" v-if="is_voucher_collected">
                        <button @click="redirectToMyVoucher()" class="btn cs-btn-default cs-primary btn-lg mb-1">View My Voucher</button>
                    </div> -->
                    <br />
                </div>
            </div>

            <br />
        </template>

        <RecordLinkedModal title="Success">
            <div class="text-center">
                <h3 class="text-success mb-3">
                    <font-awesome-icon icon="fas fa-circle-check" size="4x" />
                </h3>
                <p>The voucher is linked to your device and will show on the homepage</p>
            </div>
        </RecordLinkedModal>
    </div>
</template>

<script>
import RecordLinkedModal from '../components/_modal/RecordLinked.vue';

export default {
    components: {
        RecordLinkedModal,
    },
    data() {
        return {
            voucher_data: {},
            is_voucher_collected: false,
            loader_loading: false,
            btn_loading: false,
        };
    },
    mounted() {
        this.initMainFunction();
    },
    methods: {
        initMainFunction() {
            this.loadData();
            return true;
        },

        loadData() {
            return this.getUiData();
        },

        getUiData() {
            this.loader_loading = true;

            return app.readVoucherDetail(app.voucher_short_id).then((response_data) => {
                this.loader_loading = false;

                if (!response_data) {
                    return false;
                }

                this.voucher_data = response_data;
                app.updateVoucherView(this.voucher_data.id);

                if (this.voucher_data.display == "LINKED") {
                    app.createVoucherLink(app.device_tag, app.voucher_short_id).then((response_data) => {
                        if (response_data) {
                            this.openModal("VOUCHER_LINKED");
                        }
                    });
                }
            });
        },

        openModal(name, params = {}) {
            switch (name) {
                case "VOUCHER_LINKED":
                    const modal = new bootstrap.Modal(document.querySelector("#voucher_linked_modal"));
                    modal.show();
                    // modal.hide();

                    break;
            }
        },

        collectVoucher() {
            this.btn_loading = true;

            if (!this.voucher_data.display_status) {
                this.$toast.error("This voucher is not available");
                this.btn_loading = false;
                return false;
            }

            return app.collectVoucher(app.device_tag, this.voucher_data.id).then((response_data) => {
                this.btn_loading = false;

                if (!response_data) {
                    return false;
                }
                this.$toast.success("Your voucher has been successfully collected");

                this.redirectToMyVoucher(response_data.id);
                this.is_voucher_collected = true;
                return true;
            });
        },

        redirectToMyVoucher(record_id) {
            if (record_id) {
                app.my_voucher_record_id = record_id;
            }

            app.redirectToMyVoucher();
            return true;
        },
    },
};
</script>
